var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVehicleElectric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11499_2428)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11499_2428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6666 22.4499C36.6666 21.5039 35.8976 20.7349 34.9516 20.7349H29.9087C25.6825 20.7349 22.2593 24.1512 22.2389 28.3707C22.2321 30.5688 20.6737 32.522 18.4959 32.7942C15.8826 33.1209 13.6504 31.0792 13.6504 28.534V24.6957C17.5704 23.8994 20.5239 20.4354 20.5239 16.2773V11.9218C20.5239 11.3025 20.0271 10.8057 19.4078 10.8057H17.2777V5.42251C17.2777 4.57863 16.6652 3.83002 15.8281 3.74836C14.8686 3.65308 14.0587 4.40849 14.0587 5.35446V10.8057H9.81209V5.42251C9.81209 4.57863 9.19959 3.83002 8.35571 3.74836C7.39613 3.65989 6.58628 4.40849 6.58628 5.35446V10.8057H4.44935C3.83005 10.8057 3.33325 11.3025 3.33325 11.9218V16.2773C3.33325 20.4354 6.28684 23.8994 10.2068 24.6957V28.3366C10.2068 32.522 13.453 36.0949 17.6384 36.2514C22.0348 36.4148 25.6689 32.8895 25.6689 28.5272V28.4659C25.6689 26.0908 27.5949 24.1717 29.9632 24.1717H34.9448C35.8976 24.1649 36.6666 23.3958 36.6666 22.4499Z",
    fill: "#00810E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11499_2428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11499_2428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.3333,
    height: 33.3333,
    fill: "white",
    transform: "translate(3.33325 3.33301)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVehicleElectric);
export default __webpack_public_path__ + "static/media/icon_vehicle_electric.59fa388765f31d78204b45f76a70edcc.svg";
export { ForwardRef as ReactComponent };